import type { SxProps, Theme } from "@mui/material/styles";

export const form: SxProps<Theme> = {
  gap: 2.25,
};

export const optionsRow: SxProps<Theme> = {
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  mt: -0.25,
  gap: 1,
  flexWrap: "wrap",
};

export const termsRow: SxProps<Theme> = {
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 0.625,
  flexWrap: "wrap",
  width: "100%",
};

export const forgotPasswordLink: SxProps<Theme> = {
  fontSize: "0.8125rem",
  color: "primary.main",
  fontWeight: 600,
  cursor: "pointer",
  border: "none",
  bgcolor: "transparent",
  p: 0,
  fontFamily: "inherit",
  whiteSpace: "nowrap",
};

export const viewTermsLink: SxProps<Theme> = {
  fontSize: "0.8125rem",
  color: "primary.main",
  fontWeight: 600,
  textDecoration: "none",
  cursor: "pointer",
  border: "none",
  bgcolor: "transparent",
  p: 0,
  fontFamily: "inherit",
  whiteSpace: "nowrap",
};

export const submitWrap: SxProps<Theme> = {
  mt: 1,
};

export const serverError: SxProps<Theme> = {
  borderRadius: 2,
  alignItems: "center",
  lineHeight: 1.7,
};

export const termsError: SxProps<Theme> = {
  mt: -1,
};

export const footerText: SxProps<Theme> = {
  fontSize: "0.84375rem",
  color: "text.secondary",
};

export const footerAction: SxProps<Theme> = {
  fontSize: "0.84375rem",
  color: "primary.main",
  fontWeight: 700,
  textDecoration: "none",
  ml: 0.5,
};

export const footerLinkRow: SxProps<Theme> = {
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  gap: 0.5,
  mt: 2.75,
};
